export function makeFieldsData (data) {
  const fields = {}
  data.class_fees.forEach(function(element) {
    let feeId = `fees[${element.fee_id}][fee_id]`
    let paymentType = `fees[${element.fee_id}][payment_type]`
    let feeAmount = `fees[${element.fee_id}][fee_amount]`
    fields[feeId] = element.fee_id
    fields[paymentType] = element.payment_type
    fields[feeAmount] = element.fee_amount
  })

  data.class_internal_assessments.forEach(function(element) {
    let iaIsSelected = `internal_assessments[${element.internal_assessment_id}][is_selected]`
    fields[iaIsSelected] = true
  })

  data.class_subjects.forEach(function(element) {
    let subIsSelected = `class_subjects[${element.subject_id}][is_selected]`
    fields[subIsSelected] = true

    // if elective
    if (element.class_subject_type === 1) {
      let subElectiveId = `class_subjects[${element.subject_id}][elective_subject_id]`
      fields[subElectiveId] = element.belongs_to_subject_id
    }
    // if group
    if (element.class_subject_type === 2) {
      let subGroupId = `class_subjects[${element.subject_id}][group_subject_id]`
      fields[subGroupId] = element.belongs_to_subject_id
    }
  })

  data.class_sections.forEach(function(element) {
    let csIsSelected = `section_class_teachers[${element.section_id}][is_selected]`
    let csTeacherId = `section_class_teachers[${element.section_id}][teacher_id]`
    fields[csIsSelected] = true
    fields[csTeacherId] = element.class_teacher ? element.class_teacher.id : undefined
  })

  return fields
}
